import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4086efae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "fossil-panel"
}
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "古生物清单", -1))
const _hoisted_4 = { class: "fossil-list" }

import { ref, Ref, watch, computed } from "vue";
import * as Cesium from 'cesium';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeFeature',
  props: {
    viewer: {
        type: Cesium.Viewer,
    }
},
  setup(__props) {

const props = __props;



const store = useStore();
// const state = store.state;
const visibleValue = computed(() => store.state.timelineStore.visible);
const currentTimeValue = computed(() => parseInt(store.state.timelineStore.currentTime));

let dataTypes = ref({
    PALEOMAP: '/timeline_paleomap',
    '古生物': '/timeline_fossil'
});
let currentTypeList: Ref<string[]> = ref([]);

let geojsonCache = {};
Object.keys(dataTypes.value).map(type => {
    geojsonCache[type] = {};
});
let shownLayers: Cesium.DataSource[] = [];

watch(currentTimeValue, (newValue, _oldValue) => {
    visibleValue.value && loadGeojson(newValue);
    if (visibleValue.value) {
        (props.viewer as any).clock.currentTime = Cesium.JulianDate.fromDate(startTime.addDays(2*newValue-1))
    }
});
watch(visibleValue, (newValue) => {
    if (newValue === false) {
        clearMap();
    }
});
watch(currentTypeList, (_newValue, _oldValue) => {
    clearMap();
    loadGeojson(currentTimeValue.value);
});
const clearMap = () => {
    for (var i = 0; i < shownLayers.length; i++) {
        props.viewer?.dataSources?.remove(shownLayers[i]);
    }
    shownLayers = [];
};
const loadGeojson = (t: number) => {
    clearMap();

    currentTypeList.value.forEach((type: string) => {
        let currentGeojson = geojsonCache[type][t?.toString()];
        if (currentGeojson) {
            props.viewer?.dataSources?.add(currentGeojson);
            shownLayers.push(currentGeojson);
            return;
        }

        let path: string = dataTypes.value[type];
        path = `${path}/${t}.geojson`;
        let promise = Cesium.GeoJsonDataSource.load(path, { fill: Cesium.Color.TRANSPARENT,markerSize:0 });
        promise.then(dataSource => {
            geojsonCache[type][currentTimeValue.value.toString()] = dataSource;
            props.viewer?.dataSources?.add(dataSource);
            shownLayers.push(dataSource);

            let entities = dataSource.entities.values;
            for (let i = 0; i < entities.length; i++) {
                let entity = entities[i]
                console.log(entity);
                entity.point = new Cesium.PointGraphics({
                    color: Cesium.Color.RED.withAlpha(1.0), // 设置颜色为红色，透明度为100%
                    pixelSize: 5, // 设置点的大小为5像素
                    outlineWidth: 0 // 设置轮廓宽度为1像素
                });
            }
        });
    });
};

class CustomDate extends Date {
    addSeconds(seconds: number): CustomDate {
        const date = new CustomDate(this.getTime());
        date.setSeconds(date.getSeconds() + seconds);
        return date;
    }
    addHours(hours: number): CustomDate {
        const date = new CustomDate(this.getTime());
        date.setHours(date.getHours() + hours);
        return date;
    }
    addDays(days: number): CustomDate {
        const date = new CustomDate(this.getTime());
        date.setDate(date.getDate() + days);
        return date;
    }
    format(fmt: string): string {
        var o = {
            'M+': this.getMonth() + 1, // 月份
            'd+': this.getDate(), // 日
            'h+': this.getHours(), // 小时
            'H+': this.getHours(), // 小时
            'm+': this.getMinutes(), // 分
            's+': this.getSeconds(), // 秒
            'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
            'S': this.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length ==
                1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
        return fmt
    }
}

//城市、洲注记
let czmlAnnotionLayer:any = null;
const startTime = new CustomDate('2000-1-1 00:00:00').addHours(8);
watch(visibleValue, (v) => {
    let viewer = props.viewer as any;
    if (!v) {
        if(czmlAnnotionLayer){
            (viewer as any).dataSources.remove(czmlAnnotionLayer);
        }
        return;
    }
    if(czmlAnnotionLayer){
        viewer.dataSources.add(czmlAnnotionLayer);
        return;
    }
    fetch("/json/annotation.json").then(res=>res.json()).then(res=>{
        let czmlAnnotion = res.map((arr:any[],i:number)=>{
            let [lng, lat, year, _kind, name] = arr;
            let start = new CustomDate("1999-12-31").addDays(2*year-1).format('yyyy-MM-ddT00:00:00Z');
            let end = new CustomDate("1999-12-31").addDays(2*year).format('yyyy-MM-ddT23:59:59Z');
            let item = {
                id:`annotation-${i}`,
                name,
                position:{
                    cartographicDegrees:[lng,lat,0]
                },
                // point:{
                //     color:{
                //         rgba:[255, 0, 0, 255]
                //     },
                //     pixelSize:10
                // },
                label:{
                    text:name,
                    font: "15px Helvetica",
                    fillColor: {
                        rgba: [255, 255, 255, 255] 
                    },
                    outlineColor:{
                        rgba:[0,0,0,255]
                    },
                    outlineWidth:2,
                    style:"FILL_AND_OUTLINE",
                    pixelOffset:{
                        cartesian2:[0,-9]
                    }
                },
                availability: `${start}/${end}`
            };
            return item;
        });
        let dataSourcePromise = Cesium.CzmlDataSource.load([{
            id:"document",
            name:"annotationCzmlDocument",
            version:"1.0",
        },...czmlAnnotion]);
        dataSourcePromise.then((result) => {
            czmlAnnotionLayer = result;
            viewer.dataSources.add(result);
        });
    });
});

//古生物点点击事件
let fossilClickEventHandler:any = null;
let fossilNames:Ref<string[]> = ref([]);
let fossilPanelVisible:Ref<boolean> = ref(false);
watch(visibleValue,(v)=>{
    if(v){
        //注册点击事件
        addFossilClickEvent();
    }else{
        //注销点击事件
        fossilClickEventHandler.destroy();
    }
});
const addFossilClickEvent = ()=>{
    let viewer = props.viewer as any;
    
    if(!fossilClickEventHandler){
        let fossilClickEvent = function (movement) {
            fossilNames.value = [];
            var picked = viewer.scene.pick(movement.position);
            let names = picked?.id?.properties?.accepted_n?._value;
            if(names){
                fossilNames.value = names.split(";");
                fossilPanelVisible.value = true;
            }
        };
        fossilClickEventHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        fossilClickEventHandler.setInputAction(fossilClickEvent,Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (visibleValue.value)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          class: "time-feature",
          modelValue: _unref(currentTypeList),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentTypeList) ? (currentTypeList).value = $event : currentTypeList = $event)),
          multiple: "",
          clearable: "",
          placeholder: "选择矢量要素"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTypes), (value, field) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: field,
                value: field,
                label: field
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(fossilPanelVisible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_icon, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(fossilPanelVisible) //@ts-ignore
 ? fossilPanelVisible.value = false : fossilPanelVisible = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fossilNames), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "fossil-item"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})